/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ServiceTypeWithVCDSEnum = 'VCDR' | 'VMCFS' | 'VMUA' | 'VCDS';

export const ServiceTypeWithVCDSEnum = {

    VCDR: 'VCDR' as ServiceTypeWithVCDSEnum,

    VMCFS: 'VMCFS' as ServiceTypeWithVCDSEnum,

    VMUA: 'VMUA' as ServiceTypeWithVCDSEnum,

    VCDS: 'VCDS' as ServiceTypeWithVCDSEnum
};

